module.exports = __webpack_public_path__ + "img/logo_infobank_news.b7db72b9.png";